import { billOfMaterialsIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { BillOfMaterialsStatus } from "./bill-of-materials-types";

export const bulkUpdateBillOfMaterials = {
  name: "bulkUpdateBillOfMaterials" as const,
  input: z.object({
    billOfMaterialsIds: z.array(billOfMaterialsIdFormat.schema),
    status: BillOfMaterialsStatus.optional(),
    addTags: z.array(z.string()).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
